import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CALENDAR = 'calendar';
const LIST = 'list';

export function CalendarDaysIcon({ size = 16, color, label }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      aria-label={label}
      style={{ color, flexShrink: 0 }}
    >
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 14h.01" />
      <path d="M12 14h.01" />
      <path d="M16 14h.01" />
      <path d="M8 18h.01" />
      <path d="M12 18h.01" />
      <path d="M16 18h.01" />
    </svg>
  );
}

CalendarDaysIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  label: PropTypes.string,
};

CalendarDaysIcon.defaultProps = {
  size: 16,
  color: undefined,
  label: undefined,
};

function ListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 5h.01" />
      <path d="M3 12h.01" />
      <path d="M3 19h.01" />
      <path d="M8 5h13" />
      <path d="M8 12h13" />
      <path d="M8 19h13" />
    </svg>
  );
}

export default function ScheduleLayoutToggle({
  value,
  onChange,
}) {
  const [layout, setLayout] = useState(CALENDAR);
  const selected = value ?? layout;

  const onSelect = (next) => {
    if (value === undefined) setLayout(next);
    if (onChange) onChange(next);
  };

  return (
    <div className="schedule-layout-toggle" role="group" aria-label="Layout">
      <button
        type="button"
        className={selected === CALENDAR ? 'is-selected' : undefined}
        aria-label="Calendar view"
        aria-pressed={selected === CALENDAR}
        title="Calendar"
        onClick={() => onSelect(CALENDAR)}
      >
        <CalendarDaysIcon />
      </button>
      <button
        type="button"
        className={selected === LIST ? 'is-selected' : undefined}
        aria-label="List view"
        aria-pressed={selected === LIST}
        title="List"
        onClick={() => onSelect(LIST)}
      >
        <ListIcon />
      </button>
    </div>
  );
}

ScheduleLayoutToggle.propTypes = {
  value: PropTypes.oneOf([CALENDAR, LIST]),
  onChange: PropTypes.func,
};

ScheduleLayoutToggle.defaultProps = {
  value: undefined,
  onChange: undefined,
};
